import React, {useEffect} from 'react';
import {
  activeFiltersAtom,
  availableFilterAtom,
  currentFilterStepAtom,
  filteredNodesAtom,
  finishedAtom,
  nodesAtom, termsBundleAtom
} from "../../atoms/atoms";
import {useAtom} from "jotai";
import {NodeInterface} from "../Results/interfaces";


type NodeFilterComponent = () => JSX.Element;

const NodeFilter: NodeFilterComponent = () => {
  const [nodes] = useAtom(nodesAtom);
  const [filteredNodes, setFilteredNodes] = useAtom(filteredNodesAtom);
  const [,setAvailableFilters] = useAtom(availableFilterAtom);
  const [activeFilters, setActiveFilters] = useAtom(activeFiltersAtom)
  const [finished, setFinished] = useAtom(finishedAtom);
  const [currentStep, setCurrentStep] = useAtom(currentFilterStepAtom);

  const [termArray] = useAtom(termsBundleAtom);

  useEffect(() => {
    if (filteredNodes.length === 0 && nodes.length > 0) {
      setFilteredNodes(nodes);
    }
  }, [filteredNodes, nodes]);

  useEffect(() => {
    filterNodes();
    localStorage.setItem('sopm_active_filters', JSON.stringify(activeFilters));
  }, [activeFilters]);

  useEffect(() => {
    if (!finished && filteredNodes.length > 0) {
      updateAvailableFilters();
    }
  }, [filteredNodes])

  const resetPersistance = () => {
    setCurrentStep(0);
    setFinished(false);
    setActiveFilters([]);
    localStorage.removeItem('sopm_filter_result_view');
    localStorage.removeItem('sopm_active_filters');
  }

  const updateAvailableFilters = () => {
    if (termArray[currentStep]?.termList === undefined) {
      resetPersistance();
      return null;
    }

    const questionTermList = termArray[currentStep].termList;
    let allTerms:number[] = [];
    filteredNodes.forEach((node) => {
      allTerms = [...allTerms, ...node.tid];
    })
    if (allTerms.filter(n => questionTermList.includes(n)).length === 0) {
      localStorage.setItem('sopm_filter_result_view', 'true');
      setFinished(true);
    } else {
      localStorage.removeItem('sopm_filter_result_view');
      setAvailableFilters(allTerms);
    }
  }

  const filterNodes = () => {
    if (termArray.length && activeFilters.length > 0) {
      let nodesFiltered: NodeInterface[] = [];
      const activeFilterIds = activeFilters.map((item) => {
        return item.id;
      })
      nodes.forEach((node) => {
        if (activeFilterIds.length > 0) {
          const testArray = Array.from(new Set([...activeFilterIds, ...node.tid]));
          if (testArray.length === node.tid.length) {
            nodesFiltered.push(node);
          }
        }
      });
      if (filteredNodes.length !== nodesFiltered.length) {
        setFilteredNodes(nodesFiltered);
      }
    }
  }

  return <></>;
}

export default NodeFilter;
